import * as React from "react";
const SVGComponent = ({ color = "#1D1D1D", ...props }) => (
  <svg
    width={11}
    height={10}
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.41633 4.40992L0 5.94086L4.14131 9.875L10.6364 1.41323L9.00188 0.125L3.90089 6.77033L1.41633 4.40992Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
